export const PHONE = { 
  value: "PHONE",
  key: "admin.users.types.phone"
};
export const EMAIL = {
  value: "EMAIL",
  key: "admin.users.types.email",
};
export const NO_MFA = {
  value: "NO_MFA",
  key: "admin.users.types.noMFA",
};

export default [PHONE, EMAIL];
export const MFA_TYPE_VALUES = [PHONE.value, EMAIL.value];


// WEBPACK FOOTER //
// ./src/components/dashboard/admin/users/enum/mfaTypes.js